import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';
import { documentEndpoint } from '~/api/def/endpoints/document/documentEndpoint';

/**
 * @tags document
 * @name FundDocumentExtractedFieldGET
 * @summary Get extracted fields from a document.
 * @param docId The document ID.
 * @request GET:/document/{docId}/extracted-field
 * */
export const endpointDocumentFieldGET = async (docId: string) => {
  return await documentFieldExec<'GET'>({
    method: 'GET',
    urlExtra: `/${docId}/extracted-field`,
  });
};

/**
 * @tags document
 * @name FundDocumentExtractedFieldPOST
 * @summary Get extracted fields from a document.
 * @param docId The document ID.
 * @param fieldId The field ID.
 * @param payload The extracted field.
 * @request POST:/document/{docId}/extracted-field/{fieldId}
 * */
export const endpointDocumentFieldPOST = async (
  docId: string,
  fieldId: string,
  payload: DocumentFieldAPIModel,
) => {
  return await documentFieldExec<'POST'>({
    method: 'POST',
    urlExtra: `/${docId}/extracted-field/${fieldId}`,
    payload: payload,
  });
};

export type GetDocumentFieldResponse = BqResponse<{
  data: DocumentFieldAPIModel[];
}>;

export type DocumentFieldAPIModel = {
  id: string;
  name: string;
  value: string;
  startXCoordinate?: number;
  endXCoordinate?: number;
  startYCoordinate?: number;
  endYCoordinate?: number;
  startPageNo?: number;
  endPageNo?: number;
};

const documentFieldExec =
  getExecEndpoint<FundDocumentExtractedFieldEndpointDef>(documentEndpoint);
interface FundDocumentExtractedFieldEndpointDef {
  endpoint: typeof documentEndpoint;
  methods: {
    GET: {
      response: GetDocumentFieldResponse;
    };
    POST: {
      response: GetDocumentFieldResponse;
      payload: DocumentFieldAPIModel;
    };
  };
}
